// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentsList_comments__1hl4B"};